import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    watch,
} from '@vue/composition-api';

import { SportOfferDataStore } from '@store/modules/data/sportOffer';

export function useMatch(matchId: number) {
    const sportOfferStore = useVuexStore<SportOfferDataStore>('data/sportOffer');

    const eventsMap = sportOfferStore.getter('eventsMap');
    const isOfferReady = sportOfferStore.getter('isOfferReady');
    const fetchAndMergeEventsByIds = sportOfferStore.action('fetchAndMergeEventsByIds');

    const unwatch = watch(isOfferReady, (isReady, wasReady) => {
        if (isReady && !wasReady) {
            fetchAndMergeEventsByIds({ eventIds: [matchId], params: { oddsResults: true } });
            unwatch?.();
        }
    }, { immediate: true });

    const match = computed(() => {
        const offerMatch = eventsMap.value[matchId];
        if (!offerMatch) {
            return null;
        }

        return offerMatch;
    });

    return {
        match,
    };
}
